
export const sleep = (ms) =>  new Promise(resolve => setTimeout(resolve, ms));

export const retryableFetch = async ({axios, url, params, processResponse, retryDelayMs = 5000, maxRetries = 1}) => {
    let retries = 0;
    const attemptFetch = async () => {
        try {
            const response = await axios.get(url, {params});
            return processResponse(response);
        } catch (error) {
            if (retries < maxRetries) {
                retries++;
                await sleep(retryDelayMs);
                return attemptFetch();
            } else {
                throw error;
            }
        }
    };
    return attemptFetch();
};
